import { render, staticRenderFns } from "./wrappedForm.vue?vue&type=template&id=b990b3d4&scoped=true"
import script from "./wrappedForm.vue?vue&type=script&lang=js"
export * from "./wrappedForm.vue?vue&type=script&lang=js"
import style0 from "./wrappedForm.vue?vue&type=style&index=0&id=b990b3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b990b3d4",
  null
  
)

export default component.exports